import type { AccountState, FeatureKey } from "./api";

export const FEATURE_LOCK_MESSAGE = "利用には招待コードの適用が必要です。";

export function hasActiveEntitlement(accountState: AccountState | null | undefined): boolean {
  return accountState?.entitlementStatus === "active" && accountState.featureScope.length > 0;
}

export function canUseFeature(accountState: AccountState | null | undefined, feature: FeatureKey): boolean {
  return accountState?.entitlementStatus === "active" && accountState.featureScope.includes(feature);
}

export function canUseAnyFeature(
  accountState: AccountState | null | undefined,
  features: FeatureKey[]
): boolean {
  return accountState?.entitlementStatus === "active" && features.some((feature) => accountState.featureScope.includes(feature));
}
